
 const WEBSITE_URL = "https://api.time2dine.com";
 const SECOND_URL = "https://api.time2dine.com";


export const API_URL=WEBSITE_URL+'/api';
 export const TEST_URL=SECOND_URL+'/api';
